import { render, staticRenderFns } from "./projectSet.vue?vue&type=template&id=1effafde&scoped=true&"
import script from "./projectSet.vue?vue&type=script&lang=js&"
export * from "./projectSet.vue?vue&type=script&lang=js&"
import style0 from "./projectSet.vue?vue&type=style&index=0&id=1effafde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1effafde",
  null
  
)

export default component.exports